import {Action} from "redux";
import {GetAllClientBrowsingHistoryByClientRequest} from "../request/client_browsing_history_request";
import {GetAllClientBrowsingHistoryByClientResponse} from "../response/client_browsing_history_response";

export enum ClientClientBrowsingHistoriesActionType {
    REQUEST_GET_ALL_CLIENT_BROWSINGHISTORIES = "CLIENT_CLIENT_BROWSINGHISTORIES_REQUEST_GET_ALL_CLIENT_BROWSINGHISTORIES",
    CALLBACK_GET_ALL_CLIENT_BROWSINGHISTORIES = "CLIENT_CLIENT_BROWSINGHISTORIES_CALLBACK_GET_ALL_CLIENT_BROWSINGHISTORIES",
}

export interface IRequestGetAllClientBrowsingHistoriesAction extends Action {
    type: ClientClientBrowsingHistoriesActionType.REQUEST_GET_ALL_CLIENT_BROWSINGHISTORIES;
    item: GetAllClientBrowsingHistoryByClientRequest;
}

export interface ICallbackGetAllClientBrowsingHistoriesAction extends Action {
    type: ClientClientBrowsingHistoriesActionType.CALLBACK_GET_ALL_CLIENT_BROWSINGHISTORIES;
    isSuccess: boolean;
    item?: GetAllClientBrowsingHistoryByClientResponse;
}

export type ClientClientBrowsingHistoriesAction =
    IRequestGetAllClientBrowsingHistoriesAction |
    ICallbackGetAllClientBrowsingHistoriesAction;

export interface IClientClientBrowsingHistoriesActionCreator {
    requestGetAllClientBrowsingHistoriesAction(item: GetAllClientBrowsingHistoryByClientRequest): IRequestGetAllClientBrowsingHistoriesAction;

    callbackGetAllClientBrowsingHistoriesAction(isSuccess: boolean, item?: GetAllClientBrowsingHistoryByClientResponse): ICallbackGetAllClientBrowsingHistoriesAction;
}

class ActionCreator implements IClientClientBrowsingHistoriesActionCreator {
    public requestGetAllClientBrowsingHistoriesAction = (item: GetAllClientBrowsingHistoryByClientRequest): IRequestGetAllClientBrowsingHistoriesAction => {
        return {
            type: ClientClientBrowsingHistoriesActionType.REQUEST_GET_ALL_CLIENT_BROWSINGHISTORIES,
            item,
        };
    };

    public callbackGetAllClientBrowsingHistoriesAction = (isSuccess: boolean, item: GetAllClientBrowsingHistoryByClientResponse): ICallbackGetAllClientBrowsingHistoriesAction => {
        return {
            type: ClientClientBrowsingHistoriesActionType.CALLBACK_GET_ALL_CLIENT_BROWSINGHISTORIES,
            isSuccess,
            item,
        };
    };
}

export const createClientClientBrowsingHistoriesActionCreator = (): IClientClientBrowsingHistoriesActionCreator => {
    return new ActionCreator();
};



// WEBPACK FOOTER //
// ./src/presentation/action/client_client_browsing_histories_action.ts